import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Component, ViewChild, HostListener, ElementRef, Injector, Type } from "@angular/core";
import * as Service from "./services/bfx-blotter-ops-int-contextmenu.service";
import { BfxBaseBlotterContextMenu } from "../bfx-base-blotter/bfx-base-blotter-contextmenu";
import { trigger, state, animate, transition, style } from "@angular/animations";
const LINE_HEIGHT: number = 30;

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxBlotterOpsIntContextMenuItem } from "./models/contextmenu/BfxBlotterOpsIntContextMenuItem";
import { OpsIntPrimaryLookupService } from "shared/cubiq-services";

@Component({
  selector: "bfx-blotter-ops-int-context-menu",
  templateUrl: "./html/bfx-blotter-ops-int-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  styleUrls: ["../bfx-base-blotter/bfx-base-blotter-contextmenu.less"],
  standalone: false,
})
export class BfxBlotterOpsIntContextMenuComponent extends BfxBaseBlotterContextMenu<CubiqTS.OpsIntEventImpl> {
  constructor(
    injector: Injector,
    lookupService: OpsIntPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<Service.BfxBlotterOpsIntContextMenuService> {
    return Service.BfxBlotterOpsIntContextMenuService;
  }

  public isItemEnabled(item: BfxBlotterOpsIntContextMenuItem) {
    if (item == null) {
      return false;
    }
    return item.state.enabled;
  }

  public selectedMenuItem(item: BfxBlotterOpsIntContextMenuItem, event?: any) {
    if (this.isItemEnabled(item)) {
      (this.menuService as Service.BfxBlotterOpsIntContextMenuService).fireActionEvent(
        item.actionId,
        this.currentLadderBlotter,
        null,
        null,
        item.state,
        event,
      );
      if (item.clearSelection) {
        this.currentLadderBlotter?.gridOptions?.api?.deselectAll();
        this.currentLadderBlotter?.onSelectionChanged([]);
      }
      this.hideMenu();
    }
  }
}
